import axios from "axios";
import { ONBOARDING } from "./constant";
import { getHeaders } from "./headers";

export const userValidate = async () => {
  return await axios.get(`${ONBOARDING}/user/validate`, {
    headers: getHeaders(true),
  });
};
